module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Mirdif.9b07411e.jpg";